import { useMutation, useQuery } from "@tanstack/react-query";
import api from "../../api/axios";
import { useState } from "react";
import alertify from "alertifyjs";
export default function useCustomerHook() {
  const [submitting, setSubmitting] = useState(false);
  const { data: customers, isLoading: customersLoading } = useQuery({
    queryKey: ["customerList"],
    queryFn: async () => {
      const res = await api.get("customers/list/"); // your Django session-based customers route
      return res.data;
    },
    retry: false, // don't retry if request fails
  });
  const submitCustomerMutation = useMutation({
    mutationFn: async (customerData) => {
      const res = await api.post(
        "/accounts/users/create/customer/",
        customerData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return res.data;
    },
    onSuccess: (queryClient) => {
      // Optionally invalidate or refetch customer list here
      window.location.href = "/customers/"; // Redirect to customer list after successful submission
      queryClient.invalidateQueries(["customerList"]);
    },
    onError: (error) => {
      console.error("Error submitting customer:", error.response?.data);

      if (error.response?.data) {
        const errorData = error.response.data;
        Object.keys(errorData).forEach((field) => {
          const messages = errorData[field];
          if (Array.isArray(messages)) {
            messages.forEach((message) => {
              alertify.error(`${field}: ${message}`);
            });
          }
        });
      } else {
        alertify.error("An error occurred while submitting customer data");
      }

      setSubmitting(false); // Reset submitting state on error
    },
  });

  const updateCustomerMutation = useMutation({
    mutationFn: async ({ uuid, customerData }) => {
      const res = await api.put(`/customers/edit/${uuid}/`, customerData, {
        headers: { "Content-Type": "application/json" },
      });
      return res.data;
    },
    onSuccess: (data, variables, context) => {
      window.location.reload();
      context.queryClient.invalidateQueries(["customerList", "customer_fetch"]);
    },
    onError: (error) => {
      console.error("Error submitting customer:", error.response?.data);

      if (error.response?.data) {
        const errorData = error.response.data;
        Object.keys(errorData).forEach((field) => {
          const messages = errorData[field];
          if (Array.isArray(messages)) {
            messages.forEach((message) => {
              alertify.error(`${field}: ${message}`);
            });
          }
        });
      } else {
        alertify.error("An error occurred while submitting customer data");
      }

      setSubmitting(false); // Reset submitting state on error
    },
  });
  const FetchSingleCustomer = (uuid) => {
    const { data: customer, isLoading: customerLoading } = useQuery({
      queryKey: ["customer_fetch", uuid],
      queryFn: async () => {
        const res = await api.get(`/customers/update/${uuid}`);
        return res.data;
      },
      enabled: !!uuid, // only run if uuid is provided
      retry: false,
    });
    return { customer, customerLoading };
  };

  const FetchCustomersDocuments = (uuid) => {
    const {
      data: customersDocuments,
      isLoading: customersDocumentsLoading,
    } = useQuery({
      queryKey: ["customer_fetch", uuid],
      queryFn: async () => {
        const res = await api.get(`customers/${uuid}/documents`);
        return res.data;
      },
      enabled: !!uuid,
      retry: false,
    });
    return { customersDocuments, customersDocumentsLoading };
  };

  const submitCustomerLoading = submitCustomerMutation.isLoading;

  const sendWelcomeEmailMutation = useMutation({
    mutationFn: async (customerId) => {
      const res = await api.post(`/accounts/customers/${customerId}/send-welcome-email/`);
      return res.data;
    },
    onSuccess: () => {
      alertify.success("Welcome email sent successfully");
    },
    onError: () => {
      alertify.error("Failed to send welcome email");
    },
  });

  return {
    customers,
    customersLoading,
    submitCustomerMutation,
    submitCustomerLoading,
    FetchSingleCustomer,
    updateCustomerMutation,
    FetchCustomersDocuments,
    submitting,
    setSubmitting,
    sendWelcomeEmailMutation,
  };
}
